import { cleanEnv, str } from 'envalid';

const env = cleanEnv(process.env, {
  REACT_APP_API_BASE_URL: str({
    default: 'https://easternpacificacademy.com/api' // Always use localhost in development
  })
});
console.log('Running in', process.env.NODE_ENV, 'mode with API:', env.REACT_APP_API_BASE_URL);
export default env;
